import React from "react";
import { Grid, Typography } from "@material-ui/core";

function CenteredView({ children }) {
    return (
        <Grid container justifyContent="space-around">
            <Grid item>
                <Typography variant="h6" className="content-login">
                    {children}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default CenteredView;
